export type Endpoints = {
  getMembershipDetails: string;
  requestCard: string;
  getAppleWallet: string;
  getAndroidWallet: string;
};

export enum Environments {
  dev = 'dev',
  dev1 = 'dev1',
  dev2 = 'dev2',
  qa = 'qa',
  qa1 = 'qa1',
  qa2 = 'qa2',
  uat = 'uat',
  uat1 = 'uat1',
  uat2 = 'uat2',
  stage = 'stg',
  prod = 'prod',
}

const endpointPath: Endpoints = {
  getMembershipDetails: '/replacement-card/member',
  requestCard: '/replacement-card/request-card',
  getAppleWallet: '/replacement-card/apple-wallet',
  getAndroidWallet: '/replacement-card/android-wallet',
};

export const getLogEnvironmentFromHost = (hostname: string): string => {
  if (hostname.search('localhost') > -1) {
    return 'localhost';
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev') || hostname.startsWith('appdev2')) {
      return 'dev';
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa') || hostname.startsWith('appqa2')) {
      return 'qa';
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat') || hostname.startsWith('appuat2')) {
      return 'uat';
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return 'stage';
    } else if (hostname.startsWith('app.')) {
      return 'prod';
    } else {
      return 'unknown';
    }
  }
};

export const getEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev;
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev') || hostname.startsWith('appdev2')) {
      return Environments.dev;
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa') || hostname.startsWith('appqa2')) {
      return Environments.qa;
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat') || hostname.startsWith('appuat2')) {
      return Environments.uat;
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return Environments.stage;
    } else if (hostname.startsWith('app.')) {
      return Environments.prod;
    } else {
      return Environments.dev;
    }
  }
};

export const getWebEnvironmentFromHost = (hostname: string): string => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev;
  } else {
    if (hostname.startsWith('membership')) {
      return 'appdev1';
    } else {
      return hostname.split('.')[0];
    }
  }
};

export const getApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `common.api.ace.aaa.com`; //@TODO: confirm prod api domain!
  } else {
    return `common.api.${env}.ace.aaa.com`;
  }
};

export const getNewJoinApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `api.ace.aaa.com`;
  } else {
    return `api${env}1.ace.aaa.com`;
  }
};

export const getEndpoints = (hostname: string): Endpoints => {
  const env = getEnvironmentFromHost(hostname);
  const _endpoints: Endpoints = {
    getMembershipDetails: `https://${getApiDomain(env)}/membership-self-service${endpointPath.getMembershipDetails}`,
    requestCard: `https://${getApiDomain(env)}/membership-self-service${endpointPath.requestCard}`,
    getAppleWallet: `https://${getApiDomain(env)}/membership-self-service${endpointPath.getAppleWallet}`,
    getAndroidWallet: `https://${getApiDomain(env)}/membership-self-service${endpointPath.getAndroidWallet}`,
  };
  return _endpoints;
};

export const endpoints = getEndpoints(window.location.hostname);
